import { contentStateFromString, contentStateToString } from "@utils/richText/converters";
import { PersonDto, personFromDto } from "@domain/user/dtos";
import { PostComment } from "./postComment";
import { PostCommentDraft } from "./postCommentDraft";

export interface PostCommentDto extends Omit<PostComment, "text" | "lastUpdateDate" | "author" | "children"> {
	text: string;
	lastUpdateDate: string;
	author: PersonDto;
	children: {
		total: number;
		last?: PostCommentDto;
	};
}
export interface PostCommentDraftDto {
	text: string;
}

export function postCommentFromDto(dto: PostCommentDto): PostComment {
	return {
		...dto,
		author: personFromDto(dto.author),
		text: contentStateFromString(dto.text),
		lastUpdateDate: new Date(dto.lastUpdateDate),
		children: {
			...dto.children,
			last: dto.children.last && postCommentFromDto(dto.children.last),
		},
	};
}
export function postCommentToDto(draft: PostCommentDraft): PostCommentDraftDto {
	return {
		...draft,
		text: contentStateToString(draft.text),
	};
}
